import { render, staticRenderFns } from "./VistaCreditos.vue?vue&type=template&id=d227bdd8"
import script from "./VistaCreditos.vue?vue&type=script&lang=js"
export * from "./VistaCreditos.vue?vue&type=script&lang=js"
import style0 from "./VistaCreditos.vue?vue&type=style&index=0&id=d227bdd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports